import { useLocation } from 'react-router';
import { addQuestion, fetchQuizQuestions } from '../../firebase/utils';
import { showAlert } from '../../utils/alert'
import Context from './index';
import React, { useState } from 'react';
import { toast } from 'react-toastify';


const QuizProvider = (props) => {
  const [quiz, setQuiz] = useState(null)
  const [questionNo, setQuestionNo] = useState(0)
  const [addQuiz, setAddQuiz] = useState(false)
  const [loading, setLoading] = useState(true)
  const quizIdRegex = /\/quiz\/([^\/]+)/;
  const questionIdRegex = /\/questions\/([^\/]+)/;
  const pathname = window.location.pathname

  // Extract the IDs using match method

  const fetchQuiz = async (categoryId, quizId) => {
    const data = await fetchQuizQuestions(categoryId, quizId)
    console.log('fetching quiz')
    setQuiz(data)
    setLoading(false)
  }

  console.log("quiz", quiz)

  const deleteQuestion = async (questionIndex) => {
    const quizIdMatch = pathname.match(quizIdRegex)[1];
    const questionIdMatch = pathname.match(questionIdRegex)[1];
    const warningText = `Are you sure you want to delete Question No : ${questionIndex + 1}?`
    const isConfirm = await showAlert(warningText, 'Delete')
    const updatedState = { ...quiz };

    if (isConfirm) {
      await addQuestion(updatedState.questions, quizIdMatch, questionIdMatch)
      updatedState.questions.splice(questionIndex, 1);
      toast.success('Question deleted successfully')
      setQuestionNo(0)
      setQuiz(updatedState)

    }
  }
  return (
    <Context.Provider
      value={{
        loading,
        quiz,
        setAddQuiz,
        deleteQuestion,
        addQuiz,
        setQuestionNo,
        questionNo,
        setQuiz,
        fetchQuiz
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default QuizProvider;
